import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledHero = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl5')};
    padding-bottom: ${spacing('xl3')};
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(22, 26, 30, 0) 0%, #161a1e 65.66%);
  }

  > img {
    position: absolute;
    inset: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;

    @media (max-width: ${screen('mdMax')}) {
      &.desktop {
        display: none;
      }
    }
    @media (min-width: ${screen('md')}) {
      &.mobile {
        display: none;
      }
    }
  }
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;
  z-index: 1;
  position: relative;

  @media (min-width: ${screen('md')}) {
    text-align: center;
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xs')};
  font-size: ${fontSize('xl5')};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl6')};
    gap: ${spacing('lg')};
    align-items: center;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl9')};
    line-height: 1.12;
  }

  &::before {
    content: '';
    width: ${spacing('xl3')};
    height: ${spacing('xs2')};
    background-color: ${color('text_white')};

    @media (min-width: ${screen('md')}) {
      width: 7.5rem;
      height: ${spacing('xs')};
    }
  }
`;

export const StyledHeroDesc = styled.p`
  font-size: ${fontSize('md')};
  line-height: 1.5;
  max-width: ${container('lg')};
  margin: auto;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl2')};
  }
`;

export const StyledData = styled.div`
  margin-top: ${spacing('xl4')};
`;

export const StyledDataTitle = styled.h4`
  font-family: ${fontFamily('sans')};
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.35em;
  margin-top: 0;
  font-weight: ${fontWeight('black')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing('xs')};

  &::before,
  &::after {
    content: '';
    height: 1px;
    background-color: ${color('white')};
    flex-grow: 1;
  }

  &::before {
    @media (max-width: ${screen('mdMax')}) {
      display: none;
    }
  }
`;

export const StyledDataList = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const StyledDataItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: ${spacing('xs')};
  padding: ${spacing('md')};
  font-size: ${fontSize('md')};
  line-height: 1.5;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: ${radius('md')};
  color: ${color('text_default_inverse')};
`;

export const StyledDataValue = styled.span`
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('light')};
  font-size: ${fontSize('xl6')};
  line-height: 1;
`;
